import * as React from 'react';

const SvgSmallLink = props => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_12_80919)">
      <path
        d="M4.66667 2.91667V1.25L1.75 4.16667L4.66667 7.08333V5.375C6.75 5.375 8.20833 6.04167 9.25 7.5C8.83333 5.41667 7.58333 3.33333 4.66667 2.91667Z"
        fill="#2466EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_80919">
        <rect width="10" height="10" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSmallLink;
